"use client";

import { ArrowUpRightIcon } from "@heroicons/react/24/outline";

type Author = {
  name: string;
  link?: string;
};

export function Authors({ authors }: { authors: Author[] }) {
  return (
    <div className="mt-4 pt-6 border-t border-gray-200">
      <div className="text-sm text-gray-500">
        {authors.length === 1 ? "Author" : "Authors"}
      </div>
      <div className="flex flex-wrap gap-3 mt-2">
        {authors.map((author) => (
          <AuthorBadge key={author.name} author={author} />
        ))}
      </div>
    </div>
  );
}

function AuthorBadge({ author }: { author: Author }) {
  if (author.link) {
    return (
      <a
        href={author.link}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 px-3 py-1 text-sm bg-gray-100 rounded-full text-gray-700 interact-bounce no-underline"
        style={{ textDecorationLine: "none" }}
      >
        {author.name}
        <ArrowUpRightIcon className="h-3 w-3" />
      </a>
    );
  }

  return (
    <span className="px-3 py-1 text-sm bg-gray-100 rounded-full text-gray-700 cursor-default">
      {author.name}
    </span>
  );
}
